import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'terms-of-service',
    templateUrl: './terms-of-service.component.html',
    styleUrls: ['./terms-of-service.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class TermsOfServiceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
